import React from 'react';
import { useIntl } from 'react-intl';

import DescriptionIcon from '@mui/icons-material/Description';

import DocumentsPage from './DocumentsPage';

export default function useDocumentsPage() {
  const intl = useIntl();
  return {
    Component: DocumentsPage,
    tab: {
      label: intl.formatMessage({
        id: 'tab.documents',
        defaultMessage: 'Documentos',
      }),
      slug: 'documents',
      icon: <DescriptionIcon />,
    },
  };
}
